import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Channel Pages module configurations
export const LISTING_COLUMNS = [
  {
    id: 'channelTitle',
    label: 'Channel Title',
    width: '15%',
    align: 'left',
    dataKey: 'channelTitle',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'version',
    label: 'Package Version',
    width: '15%',
    align: 'center',
    dataKey: 'version',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'isActive',
    label: 'Is Active',
    width: '5%',
    align: 'center',
    dataKey: 'isActive',
    sortable: true,
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'previewLink',
    label: 'Preview Link',
    width: '5%',
    align: 'center',
    dataKey: 'previewLink',
    sortable: true,
    type: CELL_DATA_TYPES.LINK,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LG_LISTING_ACTIONS = [
  {
    action: ACTIONS.MAKE_ACTIVE.value,
    label: ACTIONS.MAKE_ACTIVE.label,
    conditional: (val) => !val.isActive,
  },
];
